import React from 'react';
import IndexView from 'views/NewCustomerView';

const NewCustomerPage = () => {
  return <IndexView />;
};

export default NewCustomerPage;
